<ap-drawer
  [visible]="showDrawer()"
  (visibleChange)="visibleChange($event)"
  [placement]="'right'"
  [mask]="true"
  [drawerTitle]="'footer.legalDisclaimer' | translate"
  [resizable]="false">
  @if (showDrawer()) {
    <div>
      <p>
        {{ 'footer.disclaimer.firstPart' | translate }}
      </p>
      <br />
      <p>
        {{ 'footer.disclaimer.secondPart' | translate }}
      </p>
      <br />
      <p>
        {{ 'footer.disclaimer.thirdPart' | translate }}
      </p>
    </div>
  }
</ap-drawer>
